import { create } from 'zustand';
import type { FleetWithStats } from '@scio3/shared-types';

export type MdmFleetDialogType = 'create' | 'edit' | 'delete' | null;

export interface MdmFleetDialogContext {
  fleet?: FleetWithStats;
}

interface MdmFleetsDialogState {
  activeDialog: MdmFleetDialogType;
  dialogContext: MdmFleetDialogContext;
  openDialog: (dialog: MdmFleetDialogType, context?: MdmFleetDialogContext) => void;
  closeDialog: () => void;
}

export const useMdmFleetsDialogStore = create<MdmFleetsDialogState>((set) => ({
  activeDialog: null,
  dialogContext: {},
  openDialog: (activeDialog, dialogContext = {}) => set({ activeDialog, dialogContext }),
  closeDialog: () => set({ activeDialog: null, dialogContext: {} }),
}));
